const labels: Record<string, string> = {
  'absence.read': '휴가 조회', 'absence.write': '휴가 신청·취소', 'absence.manage': '휴가 정책·잔액 관리',
  'bulk.read': '대량 작업 조회', 'bulk.write': '대량 작업 등록', 'bulk.run': '대량 작업 실행',
  'business_process.read': '결재 요청 조회', 'business_process.approve': '결재 요청 승인·반려', 'business_process.cancel': '결재 요청 취소',
  'certificates.read.self': '본인 증명서 조회', 'certificates.request.self': '본인 증명서 신청',
  'certificates.settings.read': '증명서 설정 조회', 'certificates.settings.write': '증명서 설정 변경',
  'certificates.issue': '증명서 발급', 'certificates.operations.read': '증명서 발급 내역 조회', 'certificates.revoke': '증명서 효력 취소',
  'directory.read': '조직도·동료 정보 조회', 'documents.read': '문서 조회·다운로드', 'documents.write': '문서 등록',
  'headcount.read': '포지션·정원 조회', 'headcount.write': '포지션·정원 변경',
  'lifecycle.read': '온·오프보딩 조회', 'lifecycle.write': '온·오프보딩 관리',
  'person.read': '구성원 기본 정보 조회', 'person.write': '구성원 정보 변경', 'person.name.read': '구성원 이름 조회',
  'person.career.read': '경력 정보 조회', 'person.career.write': '경력 정보 변경', 'person.career.approve': '경력 정보 변경 승인',
  'person.family.read': '가족 정보 조회', 'person.family.write': '가족 정보 변경', 'person.family.approve': '가족 정보 변경 승인',
  'person.home_contact.read': '개인 연락처 전체 조회', 'person.home_contact.masked': '개인 연락처 일부 조회',
  'person.work_contact.read': '회사 연락처 전체 조회', 'person.work_contact.masked': '회사 연락처 일부 조회',
  'person.personal_data.read': '개인 인적사항 전체 조회', 'person.personal_data.masked': '개인 인적사항 일부 조회',
  'recruiting.read': '채용 정보 조회', 'recruiting.write': '채용 정보 변경', 'recruiting.admin': '채용 운영 관리',
  'recruiting.private.read': '지원자 비공개 정보 조회', 'recruiting.private.write': '지원자 비공개 정보 변경',
  'reports.read': '보고서 조회', 'reports.export': '보고서 내보내기',
  'rewards.read': '보상 정보 조회', 'rewards.write': '보상 변경 요청', 'rewards.approve': '보상 변경 승인', 'rewards.sensitive.read': '민감한 보상 정보 조회',
  'security.read': '관리자·권한 설정 조회', 'security.manage': '관리자·권한 설정 변경', 'security.impersonate': '다른 사용자 권한으로 화면 확인',
  'staffing.read': '조직·인사 정보 조회', 'staffing.write': '조직·인사 발령 등록',
  'tenant.settings.read': '회사 설정 조회', 'tenant.settings.write': '회사 설정 변경',
  'workflow.read': '결재 운영 설정 조회', 'workflow.write': '결재 운영 설정 변경', 'workflow.run': '결재 운영 작업 실행',
  'workflow.request.cancel': '워크플로우 요청 취소', 'workflow.request.comment': '워크플로우 요청 댓글 작성',
  'workflow.request.create': '워크플로우 요청 작성', 'workflow.request.read.self': '본인 워크플로우 요청 조회',
  'workflow.request.read.all': '전체 워크플로우 요청 조회', 'workflow.request.approve': '워크플로우 요청 승인·반려',
  'workflow.request.export': '워크플로우 요청 내보내기', 'workflow.template.publish': '워크플로우 양식 게시',
  'workflow.template.read': '워크플로우 양식 조회', 'workflow.template.write': '워크플로우 양식 편집',
};

/** 표시 이름만 변환하며, 저장하는 권한 코드와 부여 범위는 바꾸지 않습니다. */
export function permissionLabel(code: string): string {
  return labels[code] ?? code;
}
